import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'jeopardy-confetti',
    templateUrl: './confetti.component.html',
    styleUrls: ['./confetti.component.scss'],
    standalone: true
})
export class ConfettiComponent implements OnInit {

  ngOnInit(): void {
  }

}
